import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ContributorsMacroRendererProps } from '../src/ContributorsMacroRenderer.tsx';

export const ContributorsMacroHandler: LoadableType<ContributorsMacroRendererProps> = LoadablePaint(
	{
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ContributorsMacro" */ '../src/ContributorsMacroRenderer.tsx'
				)
			).ContributorsMacroRenderer,
	},
);
